// Texty konce akční ceny — slovenské dvojče locale/cs/saleEnd.js.
import { plural } from '../plural.js';

export default {
  until: 'do',
  untilLong: 'Akciová cena platí do',
  endsCard: 'o',
  ends: 'končí o',
  endsLong: 'Akcia končí o',
  weekdayGenitive: ['nedele', 'pondelka', 'utorka', 'stredy', 'štvrtka', 'piatka', 'soboty'],
  dayShort: 'd',
  hourShort: 'h',
  minShort: 'min',
  days: (n) => plural(n, ['deň', 'dni', 'dní']),
  hours: (n) => plural(n, ['hodinu', 'hodiny', 'hodín']),
  minutes: (n) => plural(n, ['minútu', 'minúty', 'minút']),
};
